import {
  createSlice,
  createAsyncThunk,
} from '@reduxjs/toolkit'


const initialState = {
  reportData: {
    status: "idle",
    data: {},
    cultivationModels: [],
    crops: [],
    TopTenYields: [],
    error: {},
  },
}

export const fetchReport = createAsyncThunk('report', async (data) => {
    const {token, model, crop} = data
       const axios = require("axios")
       const headers = {
                 "Authorization" : `Bearer ${token}`,
                 "Access-Control-Allow-Origin" : "*",
                 "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
              }
      const modelURI = encodeURIComponent(model)
      const cropURI = encodeURIComponent(crop)
      const url = `/api/v0/data/cultivation_report/top/YILI?crop=${cropURI}&cultivation_model=${modelURI}` 

      const response = await axios.get(url, 
                 { headers })
      return response.data
})

const cultivationReportSlice = createSlice({
  name: 'report',
  initialState: initialState,
  reducers: {
  },
  extraReducers: {
    [fetchReport.pending.type]:(state, action) => {
      state.reportData = {
        status: "loading",
        data: {},
        crops:[],
        TopTenYields: [],
        cultivationModels: [],
        error: {},
      }
    },
    [fetchReport.fulfilled.type]:(state, action) => {
      state.reportData = {
        status: "idle",
        data: action.payload,
        cultivationModels: action.payload.CultivationModels,
        TopTenYields: action.payload.TopTenYields,
        crops: action.payload.Crops,
        error: {},
      }
    },
    [fetchReport.rejected.type]:(state, action) => {
      state.reportData = {
        status: "idle",
        data: {},
        crops: [],
        TopTenYields: [],
        cultivationModels: [],
        error: "unauthorized",
      }
    },
  }
})

export default cultivationReportSlice.reducer
